import { useAppSelector } from '../../../core/utils';
import { selectCurrentModelCode } from '../../../core/reducers/vehicles';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import useFetchLegacyInventoryStatus from '../../../core/apiHooks/useFetchLegacyInventoryStatus';
const useModelAndTrimInventoryStatus = (shouldFetch = true) => {
    const modelCode = useAppSelector(selectCurrentModelCode) || '';
    const { trimKey, transmissionKey } = useAppSelector(selectCurrentVehicle);
    const { data } = useFetchLegacyInventoryStatus([{ modelCode, trimKey, transmissionKey }], undefined, shouldFetch);
    return data && data.length > 0 && data[0] ? data[0].inventoryStatus : '';
};
export default useModelAndTrimInventoryStatus;
